function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Spinner from '../../atoms/Spinner';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';
import MenuSearch from './MenuSearch';
import MenuDropdown from './MenuDropdown';
import MenuCart from './MenuCart';
import { UserIcon, MenuIcon } from '../../atoms/Icon';
var ItemWithSubmenu = function ItemWithSubmenu(_ref) {
  var onToggleSubmenu = _ref.onToggleSubmenu,
    isOpen = _ref.isOpen,
    text = _ref.text,
    subLinks = _ref.subLinks,
    LinkTemplate = _ref.LinkTemplate,
    isActive = _ref.isActive;
  return /*#__PURE__*/React.createElement("button", {
    className: classnames('button--stripped menu__item link menu__submenu', {
      'menu__submenu--active': isActive
    }),
    onClick: onToggleSubmenu
  }, /*#__PURE__*/React.createElement("span", {
    className: "menu__submenu-link"
  }, text, /*#__PURE__*/React.createElement(SvgIcon, {
    iconName: "ico_dropArrow",
    color: "purple",
    className: classnames('icon-link__icon menu__submenu-icon', {
      'menu__submenu-icon--open': isOpen
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames('menu__submenu-container', {
      'menu__submenu-container--open': isOpen
    })
  }, subLinks.map(function (sublink) {
    return /*#__PURE__*/React.createElement(LinkTemplate, {
      key: sublink.text,
      className: "menu__subitem link",
      url: sublink.url
    }, /*#__PURE__*/React.createElement("span", {
      className: "link__content"
    }, sublink.text));
  })));
};
var MenuLinkItem = function MenuLinkItem(_ref2) {
  var link = _ref2.link,
    LinkTemplate = _ref2.LinkTemplate,
    onToggleSubmenu = _ref2.onToggleSubmenu,
    isSubmenuOpen = _ref2.isSubmenuOpen,
    isActive = _ref2.isActive;
  return /*#__PURE__*/React.createElement("li", null, link.url && /*#__PURE__*/React.createElement(LinkTemplate, {
    className: classnames('menu__item link', {
      'menu__item--active': isActive
    }),
    url: link.url
  }, /*#__PURE__*/React.createElement("span", {
    className: "link__content"
  }, link.text)), !link.url && link.subLinks && /*#__PURE__*/React.createElement(ItemWithSubmenu, {
    text: link.text,
    subLinks: link.subLinks,
    onToggleSubmenu: onToggleSubmenu,
    isOpen: isSubmenuOpen,
    isActive: isActive,
    LinkTemplate: LinkTemplate
  }));
};
var LoginButton = function LoginButton(_ref3) {
  var loginUrl = _ref3.loginUrl,
    LinkTemplate = _ref3.LinkTemplate,
    _ref3$value = _ref3.value,
    value = _ref3$value === void 0 ? 'logg inn' : _ref3$value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkTemplate, {
    className: "menu__login-button menu__login-button__mobile",
    url: loginUrl
  }, /*#__PURE__*/React.createElement(UserIcon, null)), /*#__PURE__*/React.createElement(LinkTemplate, {
    className: "menu__login-button menu__login-button__desktop button button--small",
    url: loginUrl
  }, /*#__PURE__*/React.createElement(UserIcon, {
    style: {
      height: '1rem'
    }
  }), value));
};
var MyPageButton = function MyPageButton(_ref4) {
  var myPageUrl = _ref4.myPageUrl,
    LinkTemplate = _ref4.LinkTemplate,
    _ref4$value = _ref4.value,
    value = _ref4$value === void 0 ? 'min side' : _ref4$value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkTemplate, {
    className: "menu__mypage-button menu__mypage-button__mobile",
    url: myPageUrl
  }, /*#__PURE__*/React.createElement(UserIcon, null)), /*#__PURE__*/React.createElement(LinkTemplate, {
    className: "menu__mypage-button menu__mypage-button__desktop button button--small",
    url: myPageUrl
  }, /*#__PURE__*/React.createElement(UserIcon, {
    style: {
      height: '1rem'
    }
  }), value));
};
var MyAppsDropdown = function MyAppsDropdown(_ref5) {
  var onClick = _ref5.onClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "menu__mypage-button menu__mypage-button__mobile",
    onClick: onClick,
    style: {
      marginRight: 0
    }
  }, /*#__PURE__*/React.createElement(UserIcon, null)), /*#__PURE__*/React.createElement("button", {
    className: "menu__mypage-button menu__mypage-button__desktop button button--small",
    onClick: onClick,
    style: {
      marginRight: 0
    }
  }, /*#__PURE__*/React.createElement(UserIcon, {
    style: {
      height: '1rem'
    }
  }), "mine sider"));
};
var MobileMenuButton = function MobileMenuButton(_ref6) {
  var onMenuToggle = _ref6.onMenuToggle;
  return /*#__PURE__*/React.createElement("button", {
    className: "menu__mobile-button",
    onClick: onMenuToggle,
    "aria-label": "Meny"
  }, /*#__PURE__*/React.createElement(MenuIcon, null));
};
var MenuLogo = function MenuLogo(_ref7) {
  var _ref7$logo = _ref7.logo,
    url = _ref7$logo.url,
    image = _ref7$logo.image,
    imageInverted = _ref7$logo.imageInverted,
    title = _ref7$logo.title,
    LinkTemplate = _ref7.LinkTemplate,
    onlyLogo = _ref7.onlyLogo;
  return /*#__PURE__*/React.createElement(LinkTemplate, {
    url: url,
    className: "menu__logo-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: classnames('menu__logo', {
      'menu__logo--only': onlyLogo
    }),
    src: image,
    alt: title
  }), /*#__PURE__*/React.createElement("img", {
    className: classnames('menu__logo--inverted', {
      'menu__logo--only': onlyLogo
    }),
    src: imageInverted,
    alt: ""
  }));
};
var MenuContent = function MenuContent(_ref8) {
  var menuLink = _ref8.menuLink,
    buttonValues = _ref8.buttonValues,
    openedSubmenuIndex = _ref8.openedSubmenuIndex,
    activeIndex = _ref8.activeIndex,
    _onToggleSubmenu = _ref8.onToggleSubmenu,
    logo = _ref8.logo,
    LinkTemplate = _ref8.LinkTemplate,
    onMobileMenuToggle = _ref8.onMobileMenuToggle,
    onSearchSubmit = _ref8.onSearchSubmit,
    searchLabel = _ref8.searchLabel,
    searchButtonLabel = _ref8.searchButtonLabel,
    searchButtonAbortText = _ref8.searchButtonAbortText,
    isLoggedIn = _ref8.isLoggedIn,
    logoutUrl = _ref8.logoutUrl,
    loginUrl = _ref8.loginUrl,
    myPageUrl = _ref8.myPageUrl,
    isLoading = _ref8.isLoading,
    onlyLogo = _ref8.onlyLogo,
    dropdownMenu = _ref8.dropdownMenu,
    onCartClick = _ref8.onCartClick,
    numberOfItemsInCart = _ref8.numberOfItemsInCart,
    daasLink = _ref8.daasLink;
  var _useState = useState(!!(dropdownMenu !== null && dropdownMenu !== void 0 && dropdownMenu.visible)),
    _useState2 = _slicedToArray(_useState, 2),
    menuDropdownIsVisible = _useState2[0],
    setMenuDropdownVisibilty = _useState2[1];
  var shouldShowCartIcon = !!onCartClick && numberOfItemsInCart > 0;
  var toggleMenuDropdownVisibilty = function toggleMenuDropdownVisibilty() {
    setMenuDropdownVisibilty(!menuDropdownIsVisible);
  };
  if (onlyLogo) {
    return /*#__PURE__*/React.createElement("div", {
      className: "menu__content"
    }, /*#__PURE__*/React.createElement(MenuLogo, {
      LinkTemplate: LinkTemplate,
      logo: logo,
      onlyLogo: onlyLogo
    }), shouldShowCartIcon && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "menu__content-panel"
    }), /*#__PURE__*/React.createElement("div", {
      className: "menu__content-right"
    }, /*#__PURE__*/React.createElement(MenuCart, {
      onClick: onCartClick,
      numberOfItemsInCart: numberOfItemsInCart
    }))));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "menu__content"
  }, /*#__PURE__*/React.createElement(MenuLogo, {
    LinkTemplate: LinkTemplate,
    logo: logo
  }), isLoading && /*#__PURE__*/React.createElement(Spinner, null), menuLink && /*#__PURE__*/React.createElement("ul", {
    id: "".concat(menuLink.heading && menuLink.heading.text, "-panel"),
    className: "menu__content-panel"
  }, menuLink.links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(MenuLinkItem, {
      LinkTemplate: LinkTemplate,
      isSubmenuOpen: openedSubmenuIndex === index,
      isActive: activeIndex === index,
      onToggleSubmenu: function onToggleSubmenu(event) {
        return _onToggleSubmenu(index, event);
      },
      key: link.text,
      link: link
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "menu__content-right"
  }, onSearchSubmit && /*#__PURE__*/React.createElement(MenuSearch, {
    onSubmit: onSearchSubmit,
    searchLabel: searchLabel,
    searchButtonLabel: searchButtonLabel,
    searchButtonAbortText: searchButtonAbortText
  }), shouldShowCartIcon && /*#__PURE__*/React.createElement(MenuCart, {
    onClick: onCartClick,
    numberOfItemsInCart: numberOfItemsInCart
  }), loginUrl && !isLoggedIn && /*#__PURE__*/React.createElement(LoginButton, {
    LinkTemplate: LinkTemplate,
    loginUrl: loginUrl,
    value: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.login
  }), myPageUrl && isLoggedIn && !dropdownMenu && /*#__PURE__*/React.createElement(MyPageButton, {
    LinkTemplate: LinkTemplate,
    myPageUrl: myPageUrl,
    onClick: toggleMenuDropdownVisibilty,
    value: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.myPage
  }), myPageUrl && isLoggedIn && dropdownMenu && /*#__PURE__*/React.createElement(MyAppsDropdown, {
    LinkTemplate: LinkTemplate,
    onClick: toggleMenuDropdownVisibilty
  }), /*#__PURE__*/React.createElement(MobileMenuButton, {
    onMenuToggle: onMobileMenuToggle
  })), menuDropdownIsVisible && /*#__PURE__*/React.createElement(MenuDropdown, {
    dropdownMenu: dropdownMenu,
    isLoggedIn: isLoggedIn,
    daasLink: daasLink,
    logoutUrl: logoutUrl
  }));
};
MenuContent.propTypes = {
  menuLink: PropTypes.shape({
    links: PropTypes.array,
    heading: PropTypes.shape({
      text: PropTypes.string
    })
  }),
  buttonValues: PropTypes.shape({
    login: PropTypes.string,
    myPage: PropTypes.string
  }),
  logo: PropTypes.shape({
    url: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string
  }),
  openedSubmenuIndex: PropTypes.number,
  onToggleSubmenu: PropTypes.func,
  searchLabel: PropTypes.string,
  searchButtonAbortText: PropTypes.string,
  onlyLogo: PropTypes.bool
};
export default MenuContent;